import React from "react";
import { Route } from "react-router-dom";
import { PartnerCard } from "./PartnerCard";
import { PartnerEditDialog } from "./partner-edit-dialog/PartnerEditDialog";
import { PartnerUIProvider } from "./PartnerUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export function PartnerPage({ history }) {
  const partnerUIEvents = {
    newPartnerButtonClick: () => {
      history.push("/kurban/partner/new");
    },
    openEditPartnerPage: (id) => {
      history.push(`/kurban/partner/${id}/edit`);
    },
  };

  return (
    <PartnerUIProvider partnerUIEvents={partnerUIEvents}>
      <PrivateRoute
        role={BlockOrg() && RoleChecker("Create", "access_role")}
        component={PartnerEditDialog}
        path="/kurban/partner/new"
      />
      <PrivateRoute
        role={RoleChecker("Edit", "access_role")}
        component={PartnerEditDialog}
        path="/kurban/partner/:id/edit"
      />

      <Route path="/kurban/partner/new">
        {({ history, match }) => (
          <PartnerEditDialog
            show={match != null}
            onHide={() => {
              history.push("/kurban/partner");
            }}
          />
        )}
      </Route>

      <Route path="/kurban/partner/:id/edit">
        {({ history, match }) => (
          <PartnerEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/kurban/partner");
            }}
          />
        )}
      </Route>

      <PartnerCard />
    </PartnerUIProvider>
  );
}
